// src/utils/api.js
import { useAuth } from '@clerk/clerk-react';

export const useAuthenticatedFetch = () => {
    const { getToken } = useAuth();

    return async (url, options = {}) => {
        const token = await getToken();
        const headers = {
            ...options.headers,
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        };

        return fetch(url, {
            ...options,
            headers,
        });
    };
};